import * as React from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
export var NavbarUser = function (_a) {
    var user = _a.user;
    var name = user.name, login = user.login, onSignOut = user.onSignOut, items = user.items, userLogo = user.userLogo;
    var dropdownItems = items.map(function (item, key) { return (React.createElement(Link, { key: key, className: 'dropdown-item', to: item.link, onClick: item.handleClick }, item.text)); });
    return (React.createElement("div", { className: 'navbar-user d-flex mr-2 ml-4 text-light align-items-center' },
        React.createElement(Dropdown, { className: 'mr-3 cursor_pointer' },
            React.createElement(Dropdown.Toggle, { as: 'div', id: 'dropdown-basic', className: 'd-flex' },
                React.createElement("div", null,
                    React.createElement("div", { className: 'text-light' }, name),
                    React.createElement("div", { className: 'text-muted' }, login))),
            React.createElement(Dropdown.Menu, null,
                dropdownItems,
                React.createElement(Dropdown.Divider, null),
                React.createElement(Link, { className: 'btn-sign-out dropdown-item', to: '/login', onClick: onSignOut }, "Sign out"))),
        React.createElement("img", { height: 36, width: 36, src: userLogo, alt: 'user logo' })));
};
//# sourceMappingURL=app-navbar-user.js.map